@if (roleLabel()) {
  <span
    class="__badge"
    [class.__badge--admin]="isAdminColor()"
    [class.__badge--maintainer]="isMaintainerColor()"
    [class.__badge--basic-user]="isBasicUserColor()"
    [class.__badge--read-only]="isReadOnlyColor()"
    [class.__badge--developer]="isDeveloperColor()"
    [class.__badge--guest]="isGuestColor()"
    [class.__badge--has-extra-access]="hasExtraAccess()"
    [attr.data-role]="roleCode()"
    [attr.data-variant]="colorVariant()"
    [matTooltip]="extraAccessTooltip()"
    [matTooltipDisabled]="!hasExtraAccess()"
    matTooltipClass="c-zerops-tooltip">
    {{ roleLabel() }}
    @if (hasExtraAccess()) {
      <span
        class="__marker"
        aria-hidden="true">•</span>
    }
  </span>
}
